import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { BLACK } from '../../../theme/colorConstants';

const SectionCard = ({ header, children }) => (
  <Box
    sx={{
      backgroundColor: BLACK[0],
      border: `1px solid ${BLACK[30]}`,
      borderRadius: '8px',
      overflow: 'hidden',
      width: '100%',
    }}
  >
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: BLACK[10],
        borderBottom: `1px solid ${BLACK[30]}`,
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px 16px',
      }}
    >
      {header}
    </Box>
    <Box sx={{ padding: '8px 16px' }}>{children}</Box>
  </Box>
);

SectionCard.propTypes = {
  header: PropTypes.node.isRequired,
  children: PropTypes.node,
};

export default SectionCard;
